import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { AGREEMENT_ID } from '../../../../../constants/constant-strings';
import { AMOUNT_MONEY } from '../../../../../constants/characters';
import NOB from '../../../../../constants/language-strings';
import priceFixed from '../../../../../utils/priceFixed';
import { useLocation } from 'react-router';
import { Spinner } from '@purpurds/purpur/spinner';
import { useAgreementsWithPrices } from 'modules/CustomerProducts/api';
import { PebbleSpinner, PurPurButton } from 'components';
import styled, { css } from 'styled-components';
import { purpurColorFunctionalBlack, purpurColorFunctionalWhite, purpurColorPurple800, purpurColorRed600, } from '@purpurds/tokens/color/variables';
import spacing from 'theme/spacing';
const AgreementInfoContainer = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;
const AgreementId = styled.span `
  font-size: 20px;
`;
const Price = styled.span `
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-weight: 300;
  font-size: 18px;
`;
const PriceOriginal = styled.span `
  text-decoration: line-through;
  color: ${purpurColorRed600};
`;
const StyledButton = styled(PurPurButton) `
  font-size: 14px;
  margin-top: ${spacing.spacing8};
`;
const Modal = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  margin-right: ${spacing.spacing16};
  background: ${purpurColorFunctionalWhite};
  color: ${purpurColorFunctionalBlack};
  z-index: 6;
  overflow: auto;
`;
const ModalHeader = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: ${spacing.spacing16};
  margin-bottom: ${spacing.spacing24};
`;
const FetchInfo = styled.div `
  margin-left: ${spacing.spacing8};
  min-width: 50%;
`;
const StyledCloseButton = styled(PurPurButton) `
  margin-right: ${spacing.spacing8};
  font-size: 14px;
`;
const SingleProduct = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: ${spacing.spacing4} ${spacing.spacing8};
  gap: 12px;

  ${props => props.$isTableHeading &&
    css `
      padding-bottom: ${spacing.spacing8};
      margin-bottom: ${spacing.spacing8};
      border-bottom: 1px solid ${purpurColorPurple800};
  `};
`;
const ProductName = styled.div `
  width: 50%;
`;
const ProductPrice = styled.div `
  display: flex;
  align-items: center;
  width: 20%;
`;
export const AgreementPrice = ({ customerId, agreementId, originalPrice, currentPrice, isFetchingPrices, }) => {
    const location = useLocation();
    const { pathname } = location;
    const { CUSTOMER_PRODUCTS } = NOB;
    const [showDetailedPriceModal, setShowDetailedPriceModal] = useState(false);
    // eslint-disable-next-line react/prop-types
    const showDetailedPricesForCustomerView = pathname.includes('customerInfo');
    const { data: agreementsWithPrices, refetch, isFetching, isLoading, } = useAgreementsWithPrices(customerId, showDetailedPricesForCustomerView);
    return (_jsxs(AgreementInfoContainer, { children: [_jsx(AgreementId, { children: `${AGREEMENT_ID} ${agreementId}` }), isFetchingPrices ? (_jsx(Spinner, { size: "xxs" })) : (_jsxs(Price, { children: [`${CUSTOMER_PRODUCTS.PRICE_PREFIX} ${priceFixed(currentPrice)}${AMOUNT_MONEY}`, currentPrice !== originalPrice && (_jsx(PriceOriginal, { children: `${priceFixed(originalPrice)}${AMOUNT_MONEY}` })), showDetailedPricesForCustomerView && (_jsx(StyledButton, { size: 'xs', type: 'button', variant: 'secondary', onClick: () => {
                            void refetch();
                            setShowDetailedPriceModal(state => !state);
                        }, children: "Detaljer" }))] })), showDetailedPriceModal && showDetailedPricesForCustomerView && (_jsxs(Modal, { children: [_jsxs(ModalHeader, { children: [_jsx(FetchInfo, { children: !isLoading && isFetching ? _jsx(_Fragment, { children: "Refetching prices..." }) : _jsx(_Fragment, {}) }), _jsx(StyledCloseButton, { size: 'xs', type: 'button', variant: 'secondary', onClick: () => {
                                    setShowDetailedPriceModal(state => !state);
                                }, children: "Close" })] }), agreementsWithPrices ? (agreementsWithPrices.agreements.map((agreement) => {
                        if (agreement.agreementId !== agreementId) {
                            return _jsx(_Fragment, {});
                        }
                        else {
                            return (_jsxs(_Fragment, { children: [_jsxs(SingleProduct, { "$isTableHeading": true, children: [_jsx(ProductName, { children: "Name" }), _jsx(ProductPrice, { children: "Monthly Price" }), _jsx(ProductPrice, { children: "Installation Price" })] }), !!agreement.products.length ? (agreement.products.map((product) => (_jsxs(SingleProduct, { children: [_jsx(ProductName, { children: product.name }), _jsx(ProductPrice, { children: product.monthlyPrice }), _jsx(ProductPrice, { children: product.installationPrice })] }, product.name)))) : (_jsx(_Fragment, { children: "No products found" }))] }));
                        }
                    })) : (_jsx(PebbleSpinner, {}))] }))] }));
};
